import ReadWriteRecipientViewState from 'owa-recipient-common/lib/store/schema/ReadWriteRecipientViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import isValidEmailAddress from 'owa-recipient-common/lib/utils/isValidEmailAddress';
import getReadWriteRecipientViewState from 'owa-recipient-common/lib/utils/getReadWriteRecipientViewState';

export default function convertPersonaToRecipientViewState(
    personas: FindRecipientPersonaType[],
    validationNeeded?: boolean
): ReadWriteRecipientViewState[] {
    if (personas) {
        let recipientPersonaProps = personas.map(obj => {
            let recipientPersonaProp: ReadWriteRecipientViewState = getReadWriteRecipientViewState(
                obj,
                validationNeeded ? isValidEmailAddress(obj.EmailAddress.EmailAddress) : true
            );
            return recipientPersonaProp;
        });

        return recipientPersonaProps;
    } else {
        return [];
    }
}
